import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

import * as fromAuth from './state/auth.actions';
import { AuthFlowService } from './services/auth-flow.service';
import { AuthService } from './services/auth.service';

export function authInitFactory(
  authService: AuthService,
  authFlow: AuthFlowService,
  store: Store,
): () => Promise<void> {
  return async () => {
    const credentials = authService.getCredentials();

    if (!credentials?.token) {
      store.dispatch(fromAuth.authCheck());
      return;
    }

    const remember = authService.getRememberMe();

    try {
      const response = await firstValueFrom(
        authService.verifyAuthToken(credentials.token),
      );
      if (response?.access_token) {
        store.dispatch(fromAuth.loginSuccess({ response, remember }));
      } else {
        authFlow.logout();
        store.dispatch(fromAuth.authCheck());
      }
    } catch {
      authFlow.logout();
      store.dispatch(fromAuth.authCheck());
    }
  };
}
